/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Resource, ResourceApprovalType } from '../../../shared/models';
import { CardCompletionRequirements } from '../../../shared/models/completion-logic/completion-logic.model';
import { Message } from '../../../shared/models/messages/messages.model';
import { LoadableState, defaultLoadableState } from '../../../shared/store';
import { LearnerFormAnswer } from '../models';

/** The learner view main state model. */
export interface LearnerViewStateModel {
  /** The content for the learner view. */
  resource: LoadableState<Resource>;
  completion: LoadableState<CardCompletionRequirements>;
  status: {
    learnerFormAnswers: LoadableState<LearnerFormAnswer[]>;
    startedOn: LoadableState<string>;
    updatedOn: LoadableState<string>;
    completed: LoadableState<boolean>;
    completedOn: LoadableState<string>;
    reviewStatus: LoadableState<ResourceApprovalType>;
  };
  currentLanguage: LoadableState<string>;
  cardOpened: LoadableState<boolean>;
  showMessagesBtn: boolean | null;
  cardMessagesPreview: Message[] | null;
  cardMessageTotal: number | null;
}

/** Initial empty state of the lerner view. */
export const INITIAL_STATE: LearnerViewStateModel = {
  resource: defaultLoadableState(),
  completion: defaultLoadableState(),
  status: {
    learnerFormAnswers: defaultLoadableState(),
    startedOn: defaultLoadableState(),
    updatedOn: defaultLoadableState(),
    reviewStatus: defaultLoadableState(),
    completed: defaultLoadableState(),
    completedOn: defaultLoadableState(),
  },
  currentLanguage: defaultLoadableState(),
  cardOpened: defaultLoadableState(),
  showMessagesBtn: null,
  cardMessagesPreview: null,
  cardMessageTotal: null,
};
